'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultToArray = exports.defaultToObj = exports.condDefault = undefined;

var _ramda = require('ramda');

// eslint-disable-next-line import/prefer-default-export
var condDefault = exports.condDefault = (0, _ramda.curry)(function (list, value) {
  var listWithDefault = (0, _ramda.append)([_ramda.T, _ramda.identity], list);
  return (0, _ramda.cond)(listWithDefault)(value);
});

var defaultToObj = exports.defaultToObj = (0, _ramda.defaultTo)({});

var defaultToArray = exports.defaultToArray = (0, _ramda.defaultTo)([]);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/functions.js
// module id = 244
// module chunks = 168707334958949